const SQUIGGLE_HEIGHT = 3
const SQUIGGLE_PERIOD = 6
const SQUIGGLE_COLOR = '#e5484d'

/** One period of the wave, repeated along the word: a quadratic bump and its mirror. */
const SQUIGGLE_IMAGE = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' width='${SQUIGGLE_PERIOD}' height='${SQUIGGLE_HEIGHT}' viewBox='0 0 ${SQUIGGLE_PERIOD} ${SQUIGGLE_HEIGHT}'>` +
    `<path d='M0 ${SQUIGGLE_HEIGHT - 0.75} Q${SQUIGGLE_PERIOD / 4} -0.25 ${SQUIGGLE_PERIOD / 2} ${SQUIGGLE_HEIGHT - 0.75} T${SQUIGGLE_PERIOD} ${SQUIGGLE_HEIGHT - 0.75}' fill='none' stroke='${SQUIGGLE_COLOR}' stroke-width='0.9'/>` +
    `</svg>`
)}")`

/**
 * Red wavy underlines under misspelled words, one strip per line of each word, along the bottom of
 * the line's box. Like the selection highlight it sits inside the frame, in the frame's own
 * coordinates, so it moves, scales and clips with the text, and it never takes pointer events.
 */
export function SpellUnderlines({
  rects,
}: {
  rects: ReadonlyArray<{ x: number; y: number; width: number; height: number }>
}) {
  return (
    <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
      {rects.map((rect, i) => (
        <div
          key={`shape-spell-underline-${i}`}
          className="absolute"
          style={{
            left: rect.x,
            top: rect.y + rect.height - SQUIGGLE_HEIGHT,
            width: rect.width,
            height: SQUIGGLE_HEIGHT,
            backgroundImage: SQUIGGLE_IMAGE,
            backgroundRepeat: 'repeat-x',
            backgroundSize: `${SQUIGGLE_PERIOD}px ${SQUIGGLE_HEIGHT}px`,
          }}
        />
      ))}
    </div>
  )
}
